export default { UI: '', BE: '', ENV: '' };
